export const getModifiers = prices => {
  if (!prices || prices.length === 0) return undefined;
  const isValidClassification = classification => ['low', 'medium', 'high'].includes(classification);
  const modifiers = {
    'low': [],
    'medium': [],
    'high': []
  };
  prices.forEach(p => {
    if (isValidClassification(p.classification)) {
      modifiers[p.classification].push(p.date);
    }
  });
  return Object.values(modifiers).some(arr => arr.length > 0) ? modifiers : undefined;
};